import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'button[ui-inline-button]',
  templateUrl: './inline-button.component.html',
  styleUrls: ['./inline-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIInlineButtonComponent {}
